import type { NFT } from "@stepfinance/nft";
import { buildImageURL } from "@stepfinance/react";

import NoNFTsIcon from "../../assets/no-nfts-icon.svg";

interface NFTCardImageProps {
  nft: NFT;
  onImageClick?(e: React.MouseEvent<HTMLElement, MouseEvent>, tokenInfo: NFT): void;
}

export const NFTCardImage: React.FC<NFTCardImageProps> = ({ nft, onImageClick = () => {} }) => {
  const imageUrl: string = nft.json?.image ?? "";
  return nft.json?.animation_url ? (
    <div className="thumbnail" data-image={imageUrl} onClick={(e) => onImageClick(e, nft)}>
      <video
        controls={false}
        loop={true}
        src={nft.json?.animation_url}
        poster={imageUrl}
        className="upper-corners-rounded"
      />
    </div>
  ) : (
    <div className="thumbnail">
      <img
        src={buildImageURL(imageUrl, "512")}
        alt={`Small preview of ${nft.name}`}
        onClick={(e) => onImageClick(e, nft)}
        onError={(event) => {
          event.currentTarget.src = NoNFTsIcon;
        }}
        className="upper-corners-rounded"
      />
    </div>
  );
};
